import { EventsService } from "./events.service";

export class ListenersManager {
  private destroyCallbacks = [];

  constructor(private eventsService: EventsService) {
  }

  on(name: string, listener: Function): void {
    const callback = this.eventsService.on(name, listener);
    this.destroyCallbacks.push(callback);
  }

  destroy(): void {
    this.destroyCallbacks.forEach(c => c());
  }
}
